<template>  
  <div class="log-management" @click="handleClick">  

    <!-- 汇总卡片显示区域 -->
    <div class="summary-cards">
      <!-- 主卡片容器 -->
      <div class="stats-card">
        <!-- 左侧累计授权 -->
        <div class="total-stat">
          <div class="stat-label">累计授权</div>
          <div class="stat-value">{{ summarycards.totalLicenses }}</div>
          <div class="stat-unit">次</div>
        </div>

        <!-- 右侧统计分组 -->
        <div class="detail-stats">

        <!-- 本月授权 -->
        <div class="stat-item">
          <div class="stat-label">本月处理</div>
          <div class="stat-sub-value">{{ summarycards.monthlyLicenses }} </div>
          <div class="stat-unit">次</div>
        </div>
        
        <!-- 分隔线 -->
        <div class="stat-divider"></div>

          <!-- 已授权设备 -->
        <div class="stat-item">
          <div class="stat-label">已授权设备</div>
          <div class="stat-sub-value">{{ summarycards.authorizedDevices }}</div>
          <div class="stat-unit">台</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索框区域 -->
    <div class="input-group">
      <span class="icon"><i class="fa-solid fa-magnifying-glass"></i></span> 
      <input  
        v-model="searchQuery"  
        @input="handleSearch"  
        placeholder="搜索客户或设备"  
        class="search-input"  
      /> 
    </div>

      <!-- 显示授权卡片列表 -->
      <div class="license-list" @scroll="handleScroll">  
        <div  
          class="license-card"  
          v-for="(license, index) in displayedLicenses"  
          :key="index"  
          @click="openAuthorizeModal(license)"
        >  
          <!-- 卡片左上角角标显示 -->
          <div class="badge" v-if="isExpiryDateApproaching(parseAuthDate(license.operdesc))">
              {{ getExpiryStatus(parseAuthDate(license.operdesc)) }}
          </div>

          <!-- 卡片内容显示 -->
          <img v-if="license.imageurl" :src="license.imageurl" alt="" class="license-image" />  
          <div class="license-details">  
            <div class="customer-name">{{ license.customername }}</div>  
            <div class="device-info">  
              <span>设备名称: {{ license.productname }}</span>  
            </div>  
            <div class="device-info" :class="{ 'highlight-operdate': license.operdate }">  
              <span>
                <span class="highlight-text">{{ license.username }}</span> 于 
                <span class="highlight-text">{{ formatLastLoginTime(license.operdate) }}</span> 受理
              </span>  
            </div>  
            <div class="expiry-container" :class="{ 'highlight-bg': license.expiredate }">
              授权截止日期: {{ formattedUTCdate(parseAlgorithmid(license.operdesc), parseAuthDate(license.operdesc)) }}
            </div> 
          </div>  
        </div>  
      </div> 

  </div>  
</template>  

<script>
import { ref, defineComponent, computed, onMounted, getCurrentInstance } from 'vue';
import { logData as importedlogData, summaryData } from '@/utils/publicdata'; 
import { formatLastLoginTime, getExpiryStatus } from '@/utils/dateFormatter';
import dayjs from 'dayjs';

// import axios from 'axios';
// import { API_BASE_URL } from '@/config';  // 引入配置文件

  
export default defineComponent ({  
  setup() {

    const token = ref('');
    const userid = ref('');  
    const logData = ref(importedlogData);   // 完整的卡片列表

    const searchQuery = ref('');          // 搜索查询
    const pageSize = ref(10);             // 每页显示的卡片数
    const currentPage = ref(1);           // 当前显示的页码
    const displayedLicenses = ref([]);    // 当前已显示的卡片列表

    const isLoading = ref(false);         // 是否正在加载数据 
    const showModal = ref(false);   
    const { proxy } = getCurrentInstance();

    const selectedLicense = ref({         // 当前选中的卡片信息
        productname: '',  
        customername: '',  
        username: '',  
        shortname: '',  
        expiredate: '',  
        vertypename: '',  
        slavedesc: '',  
        loccode: '',  
        regcode: '',  
        activedate: '', 
        operdate: '',
        operdesc: '', 
        algorithmid: 0,    // 默认算法类型  
        id: 0,             // 对应的后台记录ID    
        imageurl: {
          type: String,
          required: true,
        },    
      }); 

      const formattedUTCdate = (algorithmid = 0,datetime) => {
        if (algorithmid === 1)
          return proxy.$dayjs.utc(datetime).format('YYYY-MM-DD 00:00:00')
        else
          return proxy.$dayjs.utc(datetime).format('YYYY-MM-DD HH:mm:ss') 
      };  
      
      // 从JSON字符串解析并读取授权截止日期
      const parseAuthDate = (operdesc) => {
        try {
          const data = JSON.parse(operdesc);
          return  dayjs(data.authdate).format('YYYY-MM-DD HH:mm:ss')  
        }
        catch(e) {
          return new Date(NaN);  // 返回无效的日期对象 
        }
      }

      // 从JSON 字符串即系并读取算法ID
      const parseAlgorithmid = (operdesc) => {
        try {
          const data = JSON.parse(operdesc);
          return data.algorithmid  
        }
        catch(e) {
          return 0;  // 返回无效的算法ID
        }
      }

    // 使用钩子函数获取全局变量 
    onMounted(() => {  
          // 从 localStorage 获取用户信息  
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}'); 
          token.value = userInfo.token || '';
          userid.value = userInfo.userid || -1; 
        }); 

    // 搜索卡片信息的方法处理
    const handleSearch = () => {
        currentPage.value = 1;   // 重置页码
        displayedLicenses.value = [];  // 清空显示的数据
        loadLicenses();
      };

    // 用户点击事件响应
    const handleClick = (event) => {
        // 如果点击的是搜索输入框，处理输入内容响应  
        if (event.target.matches('.search-input')) {  
          handleSearch(); 
          return;
        }
    };

    // 使用computed自动同步
   const summarycards = computed(() => ({    
      totalLicenses: summaryData.value[0]?.totalcount?.toString() || '0',
      monthlyLicenses: summaryData.value[0]?.monthlycount?.toString() || '0',
      authorizedDevices: summaryData.value[0]?.devicenum?.toString() || '0'
    }));

    const loadLicenses = () => {
      if (isLoading.value) return;  //防止重复加载
      isLoading.value = true;

      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value;
      const filteredLicenses = filterLicenses.value.slice(start, end);

      // 追加新数据
      displayedLicenses.value.push(...filteredLicenses);
      // 确保数据存在
      if (filterLicenses.value.length > 0) {
        currentPage.value++;
      }
      isLoading.value = false;  // 加载完数据后复位
    };

    const filterLicenses = computed(() => {  
      let filtered = logData.value;  
  
      if (searchQuery.value) {  
        const searchLower = searchQuery.value.toLowerCase();  
        filtered = filtered.filter((license) => {  
          return (  
            (license.customername && license.customername.toLowerCase().includes(searchLower)) ||  
            (license.productname && license.productname.toLowerCase().includes(searchLower)) ||  
             (license.username && license.username.toLowerCase().includes(searchLower))  
           );  
        });  
      }  
      return filtered;  
    }); 

    const handleScroll = (event) => {
      const { scrollTop, scrollHeight, clientHeight } = event.target;

      // 判断是否滚动到底部
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        loadLicenses();    // 底部加载更多
      }
    };  

    const isExpiryDateApproaching = (expiryDate) => {  
        const today = new Date();  
        const expiry = new Date(expiryDate);  
        const diffTime = expiry - today;  
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));  
        return diffDays <= 30; // 如果距离到期日期小于或等于30天，返回true  
      };

    const openAuthorizeModal = (license) => {
      selectedLicense.value = license;
      showModal.value = true;
      document.body.style.overflow = 'hidden';  // 禁用主窗体滚动
      };  

    // 组件挂载时加载卡片列表，显示日志信息
    loadLicenses();     
    
    return {
      token,
      userid,
      logData,
      summaryData,
      searchQuery,
      currentPage,
      pageSize,
      displayedLicenses,
      selectedLicense,
      summarycards,
      
      openAuthorizeModal,
      getExpiryStatus,

      handleSearch,
      handleClick,
      handleScroll,
      isExpiryDateApproaching,
      formattedUTCdate,
      formatLastLoginTime,
      parseAuthDate,
      parseAlgorithmid,
    }
  }  
});  
</script>  

<style scoped>  
.log-management {  
    margin-top: 10px;  
}  

  /* 汇总卡片样式 */
.summary-cards {
  margin-bottom: 20px;
}

.stats-card {
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  padding: 20px;
  border: 1px solid #ebeef5;
}

/* 左侧累计授权 */
.total-stat {
  flex: 1;
  border-right: 1px solid #f0f2f5;
  padding-right: 24px;
  margin-right: 24px;
  min-width: 80px;
}

.stat-label {
  color: #909399;
  font-size: 14px;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
}

.stat-sub-value {
  font-size: 20px;
  font-weight: 500;
  color: #303133;
  line-height: 1;
}

.stat-unit {
  flex: 0 0 100px;
  font-size: 10px;
  color: #909399;
  margin-left: 50px;
  transform: translateY(-15px); /* 微调垂直对齐 */
}

/* 右侧详细统计 */
.detail-stats {
  flex: 2;
  display: flex;
  justify-content: space-between;
}

.stat-item {
  flex: 1;
  text-align: center;
}

.stat-divider {
  width: 1px;
  background: #f0f2f5;
  margin: 0 20px;
}

  /* 主界面授权列表样式 */
  .license-list {  
    display: flex;  
    flex-direction: column; 
    overflow-y: auto; /* 允许内容滚动 */  
    max-height: 500px; /* 限制高度以便出现滚动条 */  
  }  

  .license-card {  
    position: relative; /* 使角标能够定位 */  
    display: flex;  
    align-items: center;  
    padding: 10px;  
    margin-bottom: 10px;    
    border-radius: 4px;  
    background-color: white;  
    cursor: pointer; /* 提示可点击 */ 
  }

  .badge {  
    position: absolute;  
    top: 10px;  
    left: 10px;  
    background-color: red;  
    color: white;  
    padding: 5px;  
    border-radius: 3px;  
    font-size: 12px;  
  }  

  .license-image {  
    width: 100px;  
    height: 100px;  
    margin-right: 10px; 
    margin-left: 10px;
    border-radius: 8px;
  }  

  .license-details {  
    flex-grow: 1;  
  }  

  .customer-name {  
    font-weight: bold;  
    font-size: 12px; 
    text-align: left;
  }  

  .device-info {  
    margin: 5px 0;  
    font-size: 12px;
    text-align: left;
  }  

  .expiry-date {  
    color: #666;  
    font-size: 12px;
    text-align: left;
  }  


/* 橙色变量文字 */
.device-info.highlight-operdate .highlight-text {
  color: #ffb366; /* 浅橙色 */
  font-weight: 500; /* 可选加粗 */
}

/* 灰底背景容器 */
.expiry-container.highlight-bg {
  background-color: #f5f5f7; /* 浅灰背景 */
  border-radius: 5px;
  padding: 5px 15px;
  margin: 0px 0;
  
  /* 撑满容器 */
  display: block;
  width: 100%;
  box-sizing: border-box;

  /* 文字样式 */
  color: #666;
  font-size: 12px;
  position: relative;
  text-align: left;
}

  /* 搜索输入框样式 */
  .input-group {  
    display: flex; 
    align-items: center;
    position: relative;  
    margin-bottom: 20px;  
    overflow: hidden;         /* 防止内容超出输入范围 */
  }  

  .input-group .icon {  
    position: absolute;  
    left: 10px;  
    top: 50%;  
    transform: translateY(-50%);  /* 垂直居中 */
    color: #888;      
  }  

  .input-group .search-input {  
    padding: 10px 10px 10px 40px;  
    width: 100%;  
    border: 1px solid #ccc;  
    border-radius: 4px;  
    box-sizing: border-box; /* 确保包括内边距和边框在内 */ 
  }  

  .input-group .filter-button { 
    position: absolute;
    right: 4px;
    background: #ff6a00f5;   
    border: none;  
    cursor: pointer;  
    color: white;
    border-radius: 4px;   
    padding: 5px 20px 5px 20px;
    box-sizing: border-box;
  } 

</style>